<template>
<div class="chapter">
<div class="inner_page">
<p class="half">Alternatives to Valium</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half.vue?c80209c0